var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("h1", [_vm._v("Events")]),
          _vm._v(" "),
          _vm.can("viewEvents")
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn--primary",
                  attrs: { to: { name: "create-event" } },
                },
                [_vm._v("Event Setup")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("GridEvents", { attrs: { filters: _vm.filters } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }